//this is the button
// var acc = document.getElementsByClassName("course-accordion");
var i;

// for (i = 0; i < acc.length; i++) {
//   //when one of the buttons are clicked run this function
//   acc[i].onclick = function () {
//     //variables
//     var panel = this.nextElementSibling;
//     var coursePanel = document.getElementsByClassName("course-panel");
//     var courseAccordion = document.getElementsByClassName("course-accordion");
//     var courseAccordionActive = document.getElementsByClassName(
//       "course-accordion active"
//     );

//     /*if pannel is already open - minimize*/
//     if (panel.style.maxHeight) {
//       //minifies current pannel if already open
//       panel.style.maxHeight = null;
//       //removes the 'active' class as toggle didnt work on browsers minus chrome
//       this.classList.remove("active");
//     } else {
//       //pannel isnt open...
//       //goes through the buttons and removes the 'active' css (+ and -)
//       for (var ii = 0; ii < courseAccordionActive.length; ii++) {
//         courseAccordionActive[ii].classList.remove("active");
//       }
//       //Goes through and removes 'activ' from the css, also minifies any 'panels' that might be open
//       for (var iii = 0; iii < coursePanel.length; iii++) {
//         this.classList.remove("active");
//         coursePanel[iii].style.maxHeight = null;
//       }
//       //opens the specified pannel
//       panel.style.maxHeight = panel.scrollHeight + "px";
//       //adds the 'active' addition to the css.
//       this.classList.add("active");
//     }
//   }; //closing to the acc onclick function
// } //closing to the for loop.

function changeHref(anchorTag, id) {
  // Get a reference to the anchor tag by its i

  // Change the href attribute
  try{
     if (anchorTag.tagName === "A") {
    anchorTag.href = `https://www.shop.rxmens.com/cart/${id}:1?storefront=true`; // Replace with the new URL
  }
  }catch(err){
    console.log(err)
  }
 
}
function dosageOptions(array, element, elementToChange, anchorTag) {
  array.forEach((variant, index) => {
    const option = document.createElement("option");
    option.value = index;
    option.text = variant.title;
    element.appendChild(option);
  });
  element.addEventListener("change", (e) => {
    const indexToShow = e.target.value;
    qantityOption(array, elementToChange, indexToShow);
  });
  elementToChange.addEventListener("change", (e) => {
    const indexToShow = e.target.value;
    changeHref(anchorTag, indexToShow);
  });
}
function qantityOption(array, element, index, anchorTag) {
  while (element.firstChild) {
    element.removeChild(element.firstChild);
  }
  array[index].variants.forEach((variant) => {
    const option = document.createElement("option");
    const formatePrice = parseInt(variant.price);
    option.value = variant.id;
    option.text = variant.title + " tabs" + " $" + formatePrice;
    element.appendChild(option);
  });
}
function createListItem(text, className) {
  const listItem = document.createElement("li");
  listItem.textContent = text;
  if (className) {
    listItem.className = className;
  }
  return listItem;
}
function createListItem2(innerHtml, className) {
  const listItem = document.createElement("li");
  listItem.innerHTML = innerHtml;
  if (className) {
    listItem.className = className;
  }
  return listItem;
}
function createRow(item) {
  const row = document.createElement("div");
  row.className = "row";
  row.style.display = "flex";

  const col1 = document.createElement("div");
  col1.className = "col-6";

  const ul1 = document.createElement("ul");
  const listHead1 = createListItem2(item.mainTitle, "tab_price_head");
  ul1.appendChild(listHead1);

  item.variants.forEach((vari) => {
    const listItem = createListItem(`${vari.title} Tabs`);
    ul1.appendChild(listItem);
  });

  col1.appendChild(ul1);

  const col2 = document.createElement("div");
  col2.className = "col-6";

  const ul2 = document.createElement("ul");
  const listHead2 = createListItem("Price", "tab_price_head");
  ul2.appendChild(listHead2);

  item.variants.forEach((vari) => {
    const price = Number(vari.price)
    const title = Number(vari.title)
    const dived = Number(price/title);
    const result = dived.toFixed(2)
    const listItem = createListItem(`$${vari.price}/${result} ea.`);
    ul2.appendChild(listItem);
  });

  col2.appendChild(ul2);

  row.appendChild(col1);
  row.appendChild(col2);

  const tabPriceContainer = document.createElement("div");
  tabPriceContainer.className = "tab_price_container";
  tabPriceContainer.appendChild(row);

  return tabPriceContainer;
}

function createApp(array, id) {
  const coursePanel = document.getElementById(id);
  coursePanel.className = "course-panel";

  array.forEach((item, index) => {
    const row = createRow(item);
    coursePanel.appendChild(row);

    // Add class "border-0" to the last tab_price_container
    if (index === array.length - 1) {
      row.classList.add("border-0");
    }
  });
}


/* Hair Script */
